'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deserializeCharity = exports.searchCharities = exports.fetchCharity = exports.fetchCharities = exports.c = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _client = require('../../../utils/client');

var _params = require('../../../utils/params');

var _justgiving = require('../../../utils/justgiving');

var c = exports.c = {
  CAMPAIGN_SEARCH_ENDPOINT: 'v1/campaign/autocomplete',
  ENDPOINT: 'v1/charity',
  SEARCH_ENDPOINT: 'v1/onesearch'
};

var fetchCharities = exports.fetchCharities = function fetchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return Promise.reject('This method is not supported for JustGiving');
};

var fetchCharity = exports.fetchCharity = function fetchCharity() {
  var id = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();
  return (0, _client.get)(c.ENDPOINT + '/' + id);
};

var searchCharities = exports.searchCharities = function searchCharities() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (0, _params.required)();

  if (params.campaign) {
    var finalParams = _extends({}, params, {
      field: 'charityNameSuggest',
      includeFuzzySearch: true,
      maxResults: params.limit,
      campaignGuid: params.campaign
    });

    return (0, _client.get)(c.CAMPAIGN_SEARCH_ENDPOINT, finalParams, {}, { paramsSerializer: _params.paramsSerializer });
  } else {
    var _finalParams = _extends({}, params, {
      i: 'Charity'
    });

    return (0, _client.get)(c.SEARCH_ENDPOINT, _finalParams).then(function (response) {
      return response.GroupedResults && response.GroupedResults.length && response.GroupedResults[0].Results || [];
    });
  }
};

var deserializeCharity = exports.deserializeCharity = function deserializeCharity(charity) {
  var id = charity.id || charity.Id;

  return {
    active: true,
    categories: charity.categories,
    country: charity.countryCode || charity.CountryCode,
    description: charity.description || charity.Description,
    donateUrl: (0, _justgiving.baseUrl)() + '/onecheckout/donation/direct/' + id,
    email: charity.emailAddress,
    events: charity.EventIds,
    getStartedUrl: (0, _justgiving.baseUrl)() + '/fundraising-page/creation/?cid=' + id,
    id: id,
    logo: charity.logoAbsoluteUrl || ((0, _params.isURL)(charity.Logo) ? charity.Logo : (0, _justgiving.baseUrl)('images') + '/image/' + charity.Logo),
    name: charity.displayName || charity.name || charity.Name,
    registrationNumber: charity.registrationNumber,
    slug: charity.pageShortName || charity.Link && charity.Link.split('/').pop(),
    url: charity.profilePageUrl
  };
};